import { apiDelete, apiGet, apiPost, apiPut } from './api';

export async function getAllPortfolios() {
  const result = await apiGet('/portfolios');
  return result.data || [];
}

export async function getPortfolioById(id) {
  const result = await apiGet(`/portfolios/${id}`);
  return result.data || null;
}

export async function saveCustomPortfolio(data) {
  const result = await apiPost('/portfolios', data);
  return result.data;
}

export async function updatePortfolio(id, data) {
  const result = await apiPut(`/portfolios/${id}`, data);
  return result.data;
}

export async function deletePortfolio(id) {
  await apiDelete(`/portfolios/${id}`);
}

export function isDefaultPortfolio(id) {
  return String(id).startsWith('default-');
}

export function isCustomPortfolio(id) {
  return !isDefaultPortfolio(id);
}

export const emptyPortfolioForm = {
  title: '',
  titleHighlight: '',
  excerpt: '',
  content: '',
  coverImg: '',
  url: '',
  category: '',
};

export function portfolioToForm(item) {
  return {
    title: item.title || '',
    titleHighlight: item.titleHighlight || '',
    excerpt: item.excerpt || '',
    content: item.content || '',
    coverImg: item.coverImg || '',
    url: item.url || '',
    category: item.category || '',
  };
}
